import CompareField from "@/components/Form/Fields/CompareField";
import BFChooserSelect from "@/modules/abstract-ui/forms/chooser/BFChooserSelect";
import BFMessageBox from "@/modules/abstract-ui/general/Message/BFMessageBox";
import UnitStruct from "@/redux/actions/struct/implemented/UnitStruct";
import classNames from "classnames";
import { FormApi } from "final-form";
import { FormSpy } from "react-final-form";
import Collapse from "rsuite/esm/Animation/Collapse";
import FormFieldValues from "../../../../../components/Form/Fields/FormFieldValues";
import FormValidators from "../../../../../components/Form/Validation/FormValidators";
import LifeCycle from "../../../../../components/LIfeCycle/LifeCycle";
import { PDFHighlight } from "../../../../../components/PDFViewer/PDFViewer";
import i18n from "../../../../../i18n";
import { AssetTypes } from "../../../../../model/AssetTypes";
import AutosizeTextarea from "../../../../../modules/abstract-ui/forms/autosize-textarea/AutosizeTextarea";
import BFToggle from "../../../../../modules/abstract-ui/forms/toggle/BFToggle";
import BFMessage from "../../../../../modules/abstract-ui/general/Message/BFMessage";
import EZTags from "../../../../../modules/ez-form/form-elements/ez-tags/EZTags";
import LanguageService from "../../../../../services/LanguageService";
import { valueOrDefault } from "../../../../../utils/Helpers";
import { Invoice, InvoiceKind } from "../../RAInterfaces";
import { RA_INVOICE_MAIN_FIELDS } from "../../RAUtils";
import { ExtractField } from "./ExtractField";
import RAInvoiceDirectionIndicator from "./RAInvoiceDirectionIndicator";
import "./RAInvoiceForm.scss";
import { INVOICE_EXTRACT_KEYS } from "./RAInvoiceFormConst";
import RAInvoiceDefaultFields from "./invoice-sections/RAInvoiceDefaultFields";
import RAInvoiceDunningFields from "./invoice-sections/RAInvoiceDunningFields";
import RAInvoiceStornoFields from "./invoice-sections/RAInvoiceStornoFields";

//
// TODO_INVOICE:
// on change of invoice type -> reset cost center
// on change of entity -> reset cost center
//

const ACTIVATE_URGENT_FEATURE = true;
interface RAInvoiceFormProps {
  ignoreCompare?: boolean;
  prefix?: string;
  invoice: Invoice;
  form: FormApi;
  onHighlight: (highlight?: PDFHighlight | PDFHighlight[]) => void;

  uploadForm?: boolean;

  disableLinkedInvoiceChange?: boolean;
  disableInvoiceKindChange?: boolean;

  disableAll?: boolean;

  ignoreUrgent?: boolean;
  ignoreTags?: boolean;
  ignoreApprovalWarning?: boolean;
  ignoreAlreadyBookedWarning?: boolean;
}
const RAInvoiceForm = (props: RAInvoiceFormProps) => {
  const isInApproval = props.invoice.data.status === "inApproval";

  let invoicePaid = false;

  if (props.invoice.data.kind === InvoiceKind.INVOICE) {
    invoicePaid = props.invoice.data.paid;
  }

  return (
    <div className={classNames(`ra-invoice-form`)}>
      <div className={`form-head`}>
        <FormFieldValues
          names={[
            `${props.prefix || ""}${RA_INVOICE_MAIN_FIELDS().kind.identifier}`,
          ]}
        >
          {([kind]) => (
            <RAInvoiceDirectionIndicator
              kind={kind}
              direction={props.invoice?.data?.direction}
            />
          )}
        </FormFieldValues>
        <div className={`fill`} />
        {Boolean(props.ignoreUrgent) === false && (
          <CompareField
            ignoreCompare={props.ignoreCompare}
            name={`${props.prefix || ""}urgent`}
          >
            {({ input, meta }) => (
              <div
                className={classNames(`urgend-field`, {
                  urgent: input.value,
                })}
              >
                <BFToggle
                  disabled={props.disableAll}
                  size="sm"
                  labelPosition="right"
                  checked={input.value}
                  onChange={(checked) => input.onChange(checked)}
                  label={i18n.t("ra:InvoiceForm.urgent", "Dringende Rechnung")}
                />
              </div>
            )}
          </CompareField>
        )}
      </div>
      {Boolean(props.ignoreUrgent) === false && (
        <FormFieldValues names={[`${props.prefix || ""}urgent`]}>
          {([urgent]) => (
            <Collapse in={urgent} unmountOnExit>
              <div>
                <div className={`urgent-message`}>
                  <div className={`description`}>
                    {i18n.t(
                      "ra:InvoiceForm.urgentMessage",
                      "Bei einer dringenden Rechnung, werden alle Bearbeiter mit hoher Priorität benachrichtigt. Bitte geben Sie den Grund für die Dringlichkeit an."
                    )}
                  </div>
                  <CompareField
                    ignoreCompare={props.ignoreCompare}
                    name={`${props.prefix || ""}urgentComment`}
                    validate={FormValidators.compose(FormValidators.required())}
                  >
                    {({ input, meta }) => (
                      <AutosizeTextarea
                        disabled={props.disableAll}
                        maxHeight={300}
                        type={"textarea"}
                        placeholder={i18n.t(
                          "ra:InvoiceForm.urgentCommentPlaceholder",
                          "Grund der Dringlichkeit"
                        )}
                        className={`urgent-comment`}
                        {...input}
                        {...FormValidators.getValidation(meta)}
                      />
                    )}
                  </CompareField>
                </div>
              </div>
            </Collapse>
          )}
        </FormFieldValues>
      )}

      <div className={`main-form`}>
        {props.uploadForm && (
          <div className={`form-row`}>
            <div className={`field __flex-1`}>
              <ExtractField
                ignoreCompare={props.ignoreCompare}
                name={`${props.prefix || ""}${
                  RA_INVOICE_MAIN_FIELDS().kind.identifier
                }`}
                validate={FormValidators.compose(FormValidators.required())}
                invoice={props.invoice}
                onHighlight={props.onHighlight}
                field={INVOICE_EXTRACT_KEYS.kind}
                // checkExtractValue={(value: string, extractValue: string) =>
                //   value === OrgaStruct.findEntityByName(extractValue)?._id
                // }
                // disableExtraction={(value: string) =>
                //   OrgaStruct.findEntityByName(value) === undefined
                // }
                // formatValue={(value: string) =>
                //   OrgaStruct.findEntityByName(value)?.displayName
                // }
                // onExtractValueChange={(value: string) =>
                //   OrgaStruct.findEntityByName(value)?._id
                // }
              >
                {({ input, meta }) => (
                  <BFChooserSelect
                    {...FormValidators.getValidation(meta)}
                    label={RA_INVOICE_MAIN_FIELDS().kind.label + "*"}
                    cleanable={false}
                    disabled={
                      props.disableInvoiceKindChange || props.disableAll
                    }
                    data={Object.values(InvoiceKind).map((kind) => ({
                      value: kind,
                      label: i18n.t(`Invoice.kinds.${kind}`, kind),
                    }))}
                    {...input}
                    {...FormValidators.getValidation(meta)}
                    onChange={(value) => {
                      input.onChange(value);
                      // props.form.mutators.setValue("objectId", null);
                    }}
                  />
                )}
              </ExtractField>
            </div>
            <div className={`__flex-1`}></div>
          </div>
        )}

        <FormFieldValues names={[`${props.prefix || ""}invoiceKind`]}>
          {([invoiceKind]) => {
            if (invoiceKind === InvoiceKind.STORNO) {
              return (
                <RAInvoiceStornoFields {...props} invoiceKind={invoiceKind} />
              );
            }
            if (invoiceKind === InvoiceKind.DUNNING) {
              return (
                <RAInvoiceDunningFields {...props} invoiceKind={invoiceKind} />
              );
            }

            return (
              <RAInvoiceDefaultFields invoiceKind={invoiceKind} {...props} />
            );
          }}
        </FormFieldValues>

        {Boolean(props.ignoreUrgent) === false && (
          <>
            {UnitStruct.getTagConfig(
              props.invoice.data.type,
              AssetTypes.Invoicing.Invoice
            )?.length > 0 && (
              <div className={`form-row padding-top-20`}>
                <div className={`field __flex-3`}>
                  <CompareField
                    ignoreCompare={props.ignoreCompare}
                    name={`${props.prefix || ""}${
                      RA_INVOICE_MAIN_FIELDS().tags.identifier
                    }`}
                  >
                    {({ input, meta }) => (
                      <EZTags
                        disabled={props.disableAll}
                        value={input.value}
                        onChange={input.onChange}
                        onBlur={input.onBlur}
                        data={UnitStruct.getTagConfig(
                          props.invoice.data.type,
                          AssetTypes.Invoicing.Invoice
                        ).map((e) => ({
                          value: e.id,
                          label: LanguageService.translateLabel(e.displayName),
                          disabled: e.status === "archived",
                        }))}
                      />
                    )}
                  </CompareField>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {Boolean(props.ignoreApprovalWarning) === false && (
        <>
          {isInApproval && (
            <FormFieldValues
              names={[
                `${props.prefix || ""}entity`,
                `${props.prefix || ""}objectId`,
                `${props.prefix || ""}invoiceType`,
              ]}
            >
              {([entity, objectId, invoiceType]) => {
                if (
                  valueOrDefault(invoiceType, null) !==
                  valueOrDefault(props.invoice.data.invoice.invoiceType, null)
                ) {
                  return (
                    <LifeCycle
                      onUnmount={() => {
                        props.form?.mutators?.setValue(
                          `${props.prefix || ""}approvalChainChange`,
                          false
                        );
                      }}
                      onMount={() => {
                        props.form?.mutators?.setValue(
                          `${props.prefix || ""}approvalChainChange`,
                          true
                        );
                      }}
                    >
                      <BFMessage
                        type="warning"
                        text={i18n.t(
                          "ra:InvoiceForm.InvoiceTypeChanged",
                          "Sie ändern die Rechnungsart, dadurch wird die Genehmigung neu gestartet. Die Genehmiger müssen die Rechnung erneut genehmigen."
                        )}
                      />
                    </LifeCycle>
                  );
                } else if (
                  valueOrDefault(entity, null) !==
                    valueOrDefault(props.invoice.data.entity, null) ||
                  valueOrDefault(objectId, null) !==
                    valueOrDefault(props.invoice.data.objectId, null)
                ) {
                  return (
                    <BFMessage
                      type="warning"
                      text={
                        <div>
                          <CompareField
                            ignoreCompare={props.ignoreCompare}
                            name={`${props.prefix || ""}approvalChainChange`}
                          >
                            {({ input, meta }) => (
                              <LifeCycle
                                onUnmount={() => {
                                  input.onChange(false);
                                }}
                              >
                                <>
                                  <div className={`description`}>
                                    {i18n.t(
                                      "ra:InvoiceForm.ApprovalChainChange",
                                      "Durch eine Änderung des Objekts oder der Gesellschaft könnte sich die Genehmigungskette geändert haben. Wollen Sie die Genehmigung neu starten?"
                                    )}
                                  </div>
                                  <BFToggle
                                    checked={input.checked}
                                    onChange={(_val, checked) =>
                                      input.onChange(checked)
                                    }
                                    label={i18n.t(
                                      "ra:InvoiceForm.ApprovalChainChangeToggle",
                                      "Genehmigung neustarten"
                                    )}
                                  />
                                </>
                              </LifeCycle>
                            )}
                          </CompareField>
                        </div>
                      }
                    />
                  );
                } else {
                  return null;
                }
              }}
            </FormFieldValues>
          )}
        </>
      )}

      {Boolean(props.ignoreAlreadyBookedWarning) === false && (
        <>
          {props.invoice.data.booked && (
            <FormSpy subscription={{ dirty: true }}>
              {({ dirty }) => (
                <Collapse in={dirty}>
                  <div>
                    <BFMessageBox type={"info"}>
                      <div>
                        <div>
                          {i18n.t(
                            "ra:InvoiceForm.dirtyButBookedAlready",
                            "Die Rechnung wurde bereits verbucht. Änderungen werden nicht unmittelbar übernommen, sondern zunächst von der Buchhaltung geprüft und freigegeben."
                          )}
                        </div>

                        <CompareField
                          ignoreCompare={props.ignoreCompare}
                          name={`${props.prefix || ""}comment`}
                          validate={FormValidators.required()}
                        >
                          {({ input, meta }) => (
                            <AutosizeTextarea
                              disabled={props.disableAll}
                              className={`padding-top-20`}
                              maxHeight={300}
                              minHeight={100}
                              type={"textarea"}
                              label={i18n.t(
                                "ra:InvoiceForm.commentLabel",
                                "Kommentar zur Änderungsanforderung"
                              )}
                              placeholder={i18n.t(
                                "ra:InvoiceForm.commentPlaceholder",
                                "Wieso haben Sie die Rechnung geändert, obwohl sie bereits verbucht wurde?"
                              )}
                              {...input}
                              {...FormValidators.getValidation(meta)}
                            />
                          )}
                        </CompareField>
                      </div>
                    </BFMessageBox>
                  </div>
                </Collapse>
              )}
            </FormSpy>
          )}
        </>
      )}
    </div>
  );
};

export default RAInvoiceForm;
